import { render, staticRenderFns } from "./Formula.vue?vue&type=template&id=5bd0e6b9&scoped=true"
import script from "./Formula.vue?vue&type=script&lang=js"
export * from "./Formula.vue?vue&type=script&lang=js"
import style0 from "./Formula.vue?vue&type=style&index=0&id=5bd0e6b9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd0e6b9",
  null
  
)

export default component.exports